if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector(".predictive-search");
      this.clearButton = this.querySelector("[data-input-clear-button]");
      this.searchResultsWrapper = this.querySelector(
        "[data-search-results-wrapper]"
      );
      this.proxyButton = document.querySelector('.proxy-search-button');
      this.stickyHeader = document.querySelector("sticky-header");
      this.header = document.querySelector('[data-header]');

      this.headerSearchInput = document.querySelector('[data-header-search] input[type="search"]');

      this.searchCloseButton = this.querySelector('.search-modal__icon--close');
      this.searchMagnifierButton = this.querySelector('.search-modal__icon--search');
      this.menuDrawerToggle = document.querySelector("toggle-mobile-navigation");

      if (this.input && this.headerSearchInput) {
        var InputValue = this.input.value;
        if (this.input.value !== this.headerSearchInput.value) {
          this.headerSearchInput.value = InputValue;
        }
        if (InputValue != "") {
          this.input.value = ''; //clear the value of the element
          this.input.value = InputValue; //set that value back.
          this.searchCloseButton?.classList.remove('hidden');
          this.searchMagnifierButton?.classList.add('hidden');
          this.clearButton?.classList.remove("hidden");
        }
      }

      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 100).bind(this)
      );

      this.input.addEventListener("focus", () => {
        this.stickyHeader?.makeOpaque('search');
        this.showSearch();
      });

      this.input.addEventListener("blur", () => {
        if (!this.hasResults()) {
          this.stickyHeader?.makeTransparent('search');
          // document.body.classList.remove('search--is-active');
        }
      });

      if (this.proxyButton) {
        this.proxyButton.addEventListener("click", () => {
          this.toggleSearch();
        });
      }

      if (this.clearButton) {
        this.clearButton.addEventListener("click", this.clearSearch.bind(this));
      }

      if (this.searchCloseButton) {
        this.searchCloseButton.addEventListener('click', () => {
          this.hideSearch();
          //this.clearSearch();
          this.close();
          this.input.blur();
        });
      }

      if (this.menuDrawerToggle) {
        this.menuDrawerToggle.addEventListener('click', () => {
          this.hideSearch();
          this.close();
        });
      }
    }

    isOpen() {
      return this.header?.classList.contains('header__search--is-active');
    }

    toggleSearch() {
      if (this.isOpen()) {
        this.hideSearch();
        this.clearSearch();
        this.close();
      } else {
        this.showSearch();
      }
    }

    showSearch() {
      document.body.classList.add('search--is-active');
      this.header?.classList.add('header__search--is-active');

      if (document.body.classList.contains('header--is-open')) {
        document.body.classList.remove('header--is-open');
      }

      this.input.focus();
      this.stickyHeader?.makeOpaque('search');
     }

    hideSearch() {
      document.body.classList.remove('search--is-active');
      this.header?.classList.remove('header__search--is-active');
      this.stickyHeader?.makeTransparent('search');
     }

    hasResults() {
      return this.searchResultsWrapper?.children.length > 0;
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (searchTerm.length < 0 || searchTerm == "") {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
      this.clearButton?.classList.remove("hidden");
      this.stickyHeader?.makeOpaque('search');
      this.searchCloseButton?.classList.remove('hidden');
      this.searchMagnifierButton?.classList.add('hidden');

      //update search input value in header
      this.headerSearchInput.value = searchTerm;
    }

    getSearchResults(searchTerm) {
      fetch(
        `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&resources[limit]=8&section_id=predictive-search`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.stickyHeader?.makeOpaque('search');
      this.updateHeaderHeight();
      document.body.classList.add('search--is-active');
    }

    close() {
      this.searchResultsWrapper.innerHTML = "";
      this.searchCloseButton.classList.add('hidden');
      this.searchMagnifierButton.classList.remove('hidden');
      document.body.classList.remove('search--is-active');

      if (!this.hasResults()) {
        this.stickyHeader?.makeTransparent('search');
      }
    }

    clearSearch() {
      this.input.value = "";
      this.headerSearchInput.value = "";
      this.clearButton?.classList.add("hidden");
      this.searchResultsWrapper.innerHTML = "";
      this.input.focus();
    }

    updateHeaderHeight() {
      let totalHeight = this.stickyHeader?.header?.offsetHeight || 0;
      const announcementBar = document.querySelector("#shopify-section-announcement-bar");
      const announcementSlider = document.querySelector("#shopify-section-announcements-slider");

      if (announcementBar) totalHeight += announcementBar.offsetHeight;
      if (announcementSlider) totalHeight += announcementSlider.offsetHeight;

      document.documentElement.style.setProperty("--header-height", `${totalHeight}px`);
    }
  }

  window.PredictiveSearch = PredictiveSearch;

  customElements.define("predictive-search", PredictiveSearch);
}
